import {observer} from 'mobx-react';
import {Panel, FormLayout, ObjectSelect2} from 'shared/components';
import {t} from 'shared/core';
import MissingIntegrationsWarning from 'main/containers/recruiting/components/interview_schedules/MissingIntegrationsWarning';

const Interviewers = observer(({uiState}) => {
  const {interviewSchedule, users, errors} = uiState;
  const {interviewers, meetingHost} = interviewSchedule;

  return (
    <div>
      <Panel.Header title={t('recruiting.interview_schedules.edit.Interviewers')}/>
      <FormLayout>
        <ObjectSelect2
          value={interviewers}
          items={users}
          by='id'
          display='name'
          multiple
          searchable
          label='recruiting.interview_schedules.edit.Interviewers'
          placeholder='recruiting.interview_schedules.edit.Add an interviewer'
          onAdd={user => interviewSchedule.addInterviewer(user)}
          onRemove={user => interviewSchedule.removeInterviewer(user)}
          errorMessage={errors.interviewerIds}
        />
        <ObjectSelect2
          value={meetingHost}
          items={users}
          by='id'
          display='name'
          allowClear
          searchable
          label={interviewSchedule.location === 'video_conferencing'
            ? 'recruiting.interview_schedules.edit.Meeting Host'
            : 'recruiting.interview_schedules.edit.Event Host'}
          placeholder={interviewSchedule.location === 'video_conferencing'
            ? 'recruiting.interview_schedules.edit.Select a meeting host'
            : 'recruiting.interview_schedules.edit.Select an event host'}
          onChange={user => interviewSchedule.merge({meetingHost: user})}
          errorMessage={errors.meetingHostId}
        />
        <MissingIntegrationsWarning schedule={interviewSchedule}/>
      </FormLayout>
    </div>
  );
});

export default Interviewers;
